import React from 'react';
import { FadeIn } from './FadeIn';
export function Problem() {
  return <section className="py-20 px-6 bg-[#111113]" data-id="element-263">
      <div className="max-w-3xl mx-auto" data-id="element-264">
        <FadeIn data-id="element-265">
          <div className="flex items-center gap-4 mb-8" data-id="element-266">
            <div className="h-px bg-amber-500/30 flex-1" data-id="element-267" />
            <h2 className="font-bebas text-3xl sm:text-4xl uppercase tracking-wide text-amber-500" data-id="element-268">
              El Problema Real
            </h2>
            <div className="h-px bg-amber-500/30 flex-1" data-id="element-269" />
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-270">
          <p className="text-lg text-zinc-300 leading-relaxed mb-8" data-id="element-271">
            La mayoría de los hombres intentan dejar la pornografía y el
            "scroll" infinito usando moral o religión. Pero{' '}
            <strong className="text-white font-semibold" data-id="element-272">
              no puedes ganar una guerra biológica con herramientas psicológicas
              débiles.
            </strong>
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-273">
          <div className="bg-zinc-950 border border-zinc-800 rounded-2xl p-8 sm:p-10 text-center relative overflow-hidden" data-id="element-274">
            <div className="absolute top-0 right-0 w-32 h-32 bg-red-500/5 rounded-full blur-3xl" data-id="element-275" />

            <p className="text-lg text-zinc-300 leading-relaxed mb-6 relative z-10" data-id="element-276">
              Cada vez que cedes, tus receptores de dopamina se "apagan" para
              protegerse. Por eso nada te motiva, por eso procrastinas hasta lo
              más simple y por eso sientes que te cuesta mirar a las personas a
              los ojos.
            </p>

            <div className="py-6 relative z-10" data-id="element-277">
              <span className="block text-zinc-400 text-sm uppercase tracking-widest mb-2" data-id="element-278">
                Estás funcionando al
              </span>
              <span className="font-bebas text-7xl sm:text-8xl text-amber-500 leading-none block drop-shadow-[0_0_15px_rgba(245,158,11,0.2)]" data-id="element-279">
                20%
              </span>
              <span className="block text-zinc-400 text-sm uppercase tracking-widest mt-2" data-id="element-280">
                de tu capacidad real
              </span>
            </div>

            <p className="text-lg text-zinc-300 leading-relaxed mt-6 relative z-10" data-id="element-281">
              Estás viviendo en un estado de desensibilización constante.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}